import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class FileNotFoundGitError extends GitError {
  constructor(filePath: string, append = true) {
    super(append ? `File at "${filePath}" does not exist` : filePath);
  }

  readonly gitErrorCode = GitErrorStatusCode.FileNotFound;
}
